// Module
var code = `<div appHeaderBar><header-bar-title>My Account - Add Card</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text" tid="addCardHeader">My Account - Add Card</h1>
        </div>
        <div class="HOA-container__content">
            <app-credit-card-checkout-add
                    (onReturn)="onReturn()"
                    (onReady)="onReady()">
            </app-credit-card-checkout-add>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;